import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NewApiResponse } from '../../../services/new-api-http.service';

@Component({
	selector: 'app-return-to-widget-library',
	templateUrl: './returntowidgetlibrary.component.html',
	styleUrls: ['./returntowidgetlibrary.component.scss']
})
export class ReturnToWidgetLibraryComponent implements OnInit, OnDestroy {
	// @Input() componentTypeID: string;
	@Input() type: string;

	componentType;
	componentName;
	title;
	supportedComponentsSubscription: Subscription;

	componentPageTypeTitle = 'Creation of';
	reportPageTypeTitle = 'Component Report';

	constructor(private component: ComponentService) {}

	ngOnInit() {
		if (this.type === 'report') {
			this.title = this.reportPageTypeTitle;
		} else {
			this.component.componentData.pipe(filter((data) => data !== null)).subscribe((result) => {
				this.componentType = result.config.type;
				this.setComponentName();
			});
		}
	}

	setComponentName() {
		if (this.componentType) {
			this.supportedComponentsSubscription = this.component.getSupportedComponents().subscribe((response: NewApiResponse) => {
				if (response && response.status) {
					const componentDetails = response.data.filter((item) => item.type === this.componentType);
					this.componentName = componentDetails[0].description ? componentDetails[0].description : 'Component';
					this.title = `${this.componentPageTypeTitle} ${this.componentName}`;
				}
			});
		}
	}

	ngOnDestroy() {
		if (this.supportedComponentsSubscription) {
			this.supportedComponentsSubscription.unsubscribe();
		}
	}
}
